import { Types, Actions } from './actions';
import { NO_SAML_REDIRECT, SAML_REDIRECT_PARAM } from './constants';
import authApi from '~/api';
import { Actions as AuthActions } from '~/store/auth/actions';
import { Actions as PasswordActions } from '~/store/password/actions';
import { get } from '~/utils/object';

const SAML_REDIRECT_CODE = 417;
const UNAUTHORIZED = 401;
const NETWORK_PROBLEMS = new Set([
  'NETWORK_ERROR',
  'TIMEOUT_ERROR',
  'CONNECTION_ERROR',
]);
const NETWORK_ERROR_MESSAGE =
  'Unable to connect. Please check your network and try again.';

const userNameLoginRequest = (store: any) => (next: any) => (action: any) => {
  if (action.type === Types.USERNAME_LOGIN_REQUEST) {
    const redirectPath = '';
    const { username, runningOnBackground } = action.payload;
    const { dispatch } = store;
    if (username === '') {
      return dispatch(
        Actions.USERNAME_LOGIN_FAILURE(
          'Please enter your username or email address.',
        ),
      );
    } else {
      void authApi
        .post('/auth/sso', {
          username,
          redirectPath,
        })
        .then(res => {
          const { status, data, problem } = res;
          if (problem && NETWORK_PROBLEMS.has(problem)) {
            dispatch(Actions.USERNAME_LOGIN_ERROR(NETWORK_ERROR_MESSAGE));
            return;
          }
          if (status === SAML_REDIRECT_CODE) {
            const redirectTo = get<string>(
              data,
              SAML_REDIRECT_PARAM,
              NO_SAML_REDIRECT,
            );
            dispatch(Actions.USERNAME_LOGIN_SUCCESS(redirectTo));
          } else if (!runningOnBackground) {
            dispatch(Actions.USERNAME_LOGIN_FAILURE(null));
          }
        });
    }
  }
  next(action);
};

const passwordLoginRequest = (store: any) => (next: any) => (action: any) => {
  if (action.type === Types.PASSWORD_LOGIN_REQUEST) {
    const { username, password } = action.payload;
    const { dispatch } = store;

    if (username === '' && password === '') {
      return dispatch(
        Actions.PASSWORD_LOGIN_FAILURE(
          'Please enter your username or email address.',
        ),
      );
    }
    if (username === '') {
      return dispatch(
        Actions.PASSWORD_LOGIN_FAILURE(
          'Please enter your username or email address.',
        ),
      );
    }
    if (password === '') {
      return dispatch(
        Actions.PASSWORD_LOGIN_FAILURE('Please enter your password.'),
      );
    }

    void authApi
      .post('/auth/login', {
        username,
        password,
      })
      .then((res: any) => {
        const { ok, data, status, problem } = res;
        if (problem && NETWORK_PROBLEMS.has(problem)) {
          dispatch(Actions.PASSWORD_LOGIN_ERROR(NETWORK_ERROR_MESSAGE));
          return;
        }
        const resetToken = get(data, 'resetToken', null);
        if (ok) {
          const user = get(data, 'user', null);
          const accessToken = get(data, 'accessToken', null);
          dispatch(AuthActions.SET_USER({ user })); // todo: no need to encapsulate this
          dispatch(AuthActions.SET_TOKEN(accessToken));
          dispatch(Actions.PASSWORD_LOGIN_SUCCESS(data));
        } else if (resetToken) {
          dispatch(Actions.PASSWORD_LOGIN_RESET());
          dispatch(PasswordActions.SET_RESET_TOKEN({ resetToken }));
        } else {
          if (status === UNAUTHORIZED) {
            const msg = 'Your credentials are invalid. Please try again.';
            dispatch(Actions.PASSWORD_LOGIN_FAILURE(msg));
          } else {
            const msg = get(res, 'data.error.message');
            dispatch(Actions.PASSWORD_LOGIN_FAILURE(msg));
          }
        }
      });
  }

  next(action);
};

export default [userNameLoginRequest, passwordLoginRequest];
